// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JWo2","tabsBox":"styles_tabsBox__3RfRo","createButton":"styles_createButton__3GHgj"};